/**
 * 入力フォームで使用する設定定義
 */
export class InputItemSettings {
  // 未設定
  static readonly NOT_SET: InputItemMaster = {
    value: '',
    name: '未設定',
  }
  // 1回（回数）
  static readonly SINGLE_NUMBER: InputItemMaster = {
    value: 'true',
    name: '1回',
  }
  // 複数（回数）
  static readonly MULTI_NUMBER: InputItemMaster = {
    value: 'false',
    name: '複数',
  }
  // 時間（終了条件）
  static readonly END_CONDITION_TIME: InputItemMaster = {
    value: 'true',
    name: '時間',
  }
  // 任意（終了条件）
  static readonly END_CONDITION_ANY: InputItemMaster = {
    value: 'false',
    name: '任意',
  }
  // 回数プルダウンオプションのリスト
  static readonly NUMBER_LIST = [
    InputItemSettings.NOT_SET,
    InputItemSettings.SINGLE_NUMBER,
    InputItemSettings.MULTI_NUMBER,
  ]
  // 終了条件プルダウンオプションのリスト
  static readonly END_CONDITION_LIST = [
    InputItemSettings.NOT_SET,
    InputItemSettings.END_CONDITION_TIME,
    InputItemSettings.END_CONDITION_ANY,
  ]
}

export type InputItemMaster = {
  // 値
  value: string
  // 名称
  name: string
}
